/* eslint-disable react/require-default-props */
import React from 'react';
import { FinishedData, ManagementState } from 'store/modules/management_store/types';
import DataTable from 'react-data-table-component';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import Loader from 'components/atoms/loader';
import { ProfileState } from 'store/modules/profile_store/types';
import companyId from 'services/company_id';
import { datatableColumns, datatableData } from './datatable_list';
import { ContainerFinishedList } from './styles';

interface FinishedListProps {
  finishedList: Array<FinishedData>;
  toggleSelected?: (id: number, updateAll?: boolean) => void;
  selectedFinished: Array<number>;
}

const FinishedList = (props: FinishedListProps) => {
  const { finishedList, selectedFinished, toggleSelected = () => {} } = props;

  const { request } = useSelector<ApplicationState, ManagementState>(
    (state) => state.session.management,
  );

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const customStyles = {
    headCells: {
      style: {
        paddingLeft: '10px',
        paddingRight: '10px',
      },
    },
    cells: {
      style: {
        paddingLeft: '10px',
        paddingRight: '10px',
      },
    },
    rows: {
      style: {
        fontSize: '14px',
      },
    },
  };

  return (
    <>
      {request.finished.loading && <Loader />}
      {request.finished.loaded && (
        <ContainerFinishedList>
          <DataTable
            columns={datatableColumns(toggleSelected)}
            customStyles={customStyles}
            data={datatableData(finishedList, companyId(profile), selectedFinished)}
            noDataComponent={
              <div className="p-5 w-100 text-center">
                Você e a sua equipe não tem licitações finalizadas.
              </div>
            }
          />
        </ContainerFinishedList>
      )}
    </>
  );
};

export default FinishedList;
